import React, { useContext, useMemo, useState } from 'react';
import { STYLES } from '../../consts';
import Heading from '../../../../generic-components/Heading';
import Button from '../../../../generic-components/Button';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/svg/shared/ic-shared-calendar.svg';
import { ReactComponent as ChevronIcon } from '../../../../assets/transactions-new/chevron.svg';
import { FilterDatePickerWrapper } from './FilterDatePickerWrapper';
import { FlowContext } from '../TransactionsWrapper';
import { useStore } from '../../../../store';

export const TransactionsPeriodTrigger = () => {
  const [isPeriodPickerShown, setIsPeriodPickerShown] = useState<boolean>(false);
  const ctx = useContext(FlowContext);
  const filterObject = useStore(state => state.filterObject);

  const triggerTitle = useMemo(() => ctx.localizedString(), [filterObject]);

  return (
    <div id='periodTriggerWrapper' className='relative'>
      <Button
        className={STYLES.FILTER_PERIOD_TRIGGER}
        avoidStopPropagation
        id='periodTrigger'
        onClick={() => setIsPeriodPickerShown(prevState => !prevState)}
        childElement={(
          <div className={STYLES.PERIOD_TRIGGER.WRAPPER}>
            <CalendarIcon className='mr-[6px] w-[16px] text-bw08' />
            <Heading testId='periodRangeValue' title={triggerTitle} className={STYLES.PERIOD_TRIGGER.TITLE} />
            <ChevronIcon className='w-[18px]' />
          </div>
        )}
      />
      {isPeriodPickerShown && <FilterDatePickerWrapper closeFilter={() => setIsPeriodPickerShown(false)} />}
    </div>
  );
};
